import setFieldValue from "@bevco/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@bevco/Store/Reducers";
import {
    OwnProps,
    setRequestFormEffects,
} from "@bevco/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    userEmail: state.customCreateAccountForm.fieldValues.userEmail,
    confirmUserEmail: state.customCreateAccountForm.fieldValues.confirmUserEmail,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const confirmUserEmailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const ConfirmUserEmail: React.FC<Props> = ({confirmUserEmail, userEmail, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Confirm Email Address");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validateEmail = () => {
        let errorMessage: any = "";
        if (!confirmUserEmail && isRequired) {
            errorMessage = siteMessage("Field_Required", label);
        } else if (confirmUserEmail && !confirmUserEmailRegexp.test(confirmUserEmail)) {
            errorMessage = siteMessage("ContactUsForm_EmailIsInvalidErrorMessage");
        } else if (confirmUserEmail && confirmUserEmail !== userEmail) {
            errorMessage = translate("Emails don't match");
        }

        setFieldErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    setRequestFormEffects(isRequired, confirmUserEmail, "confirmUserEmail", validateEmail);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "confirmUserEmail", value: event.target.value });
    };

    const fieldBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        validateEmail();
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={confirmUserEmail || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            onBlur={fieldBlurHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmUserEmail);
